import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './DataProcessingAgreement.css';

function DataProcessingAgreement() {
  const [content, setContent] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch('/data_processing_agreement.md')
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="data-processing-agreement">
      <div className="data-processing-agreement-container">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default DataProcessingAgreement;
